import { getSession } from '@/core';
import { httpClient } from './httpClient';
import { parseAppSummary } from './schemas/technician';
import type { TechAppSummary } from '@/domain/technician';

function technicianId(): string {
  const user = getSession().user;
  if (user === null) throw new Error('Sessão sem técnico vinculado.');
  return user.id;
}

/** GET /technicians/{id}/app-summary — agregador da Home (TEL-01). */
export async function fetchAppSummary(): Promise<TechAppSummary> {
  const payload = await httpClient.get<unknown>(`/technicians/${technicianId()}/app-summary`);
  return parseAppSummary(payload);
}

/** PUT /profile/{id}/availability — toggle de disponibilidade (TEL-01). */
export async function setAvailability(isAvailable: boolean): Promise<void> {
  await httpClient.put<unknown>(`/profile/${technicianId()}/availability`, { isAvailable });
}
